export default __webpack_public_path__ + "static/media/fun_jun2020_pt1.56e6185c.bmp";